import { render, staticRenderFns } from "./PackagesTypeList.vue?vue&type=template&id=2f904fa6&scoped=true"
import script from "./PackagesTypeList.vue?vue&type=script&lang=js"
export * from "./PackagesTypeList.vue?vue&type=script&lang=js"
import style0 from "./PackagesTypeList.vue?vue&type=style&index=0&id=2f904fa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f904fa6",
  null
  
)

export default component.exports